// 额度以服务端为准。缺失/非法值不是0，不在前端推算调用次数。
export function quotaView(value) {
  if (!value || value.unit !== 'TOKEN') return null
  const fields = ['totalTokens', 'usedTokens', 'reservedTokens', 'remainingTokens', 'minimumRequestTokens']
  const numbers = {}
  for (const key of fields) {
    const raw = value[key]
    if (typeof raw !== 'number' && !(typeof raw === 'string' && /^\d+$/.test(raw))) return null
    const n = Number(raw)
    if (!Number.isSafeInteger(n) || n < 0) return null
    numbers[key] = n
  }
  if (numbers.remainingTokens > numbers.totalTokens || numbers.minimumRequestTokens < 1) return null
  return numbers
}

// Normal reservation is shown only inside the quota panel, never as a composer warning.
export function quotaWarning(summary) {
  if (!summary || !summary.notice || !['low', 'exhausted'].includes(summary.notice.level)) return null
  const percent = summary.remainingPercent
  return typeof percent === 'number' && Number.isFinite(percent) && percent >= 0 && percent <= 10 ? summary.notice : null
}
